import {Avatar} from '@components/ui/avatar'
import {LinkExternal01Icon, LogOut01Icon, Settings01Icon} from '@components/ui/icon'
import {useMe} from '@features/user/queries/useMe.ts'
import {raise} from '@utilities/helpers.ts'
import {useTranslation} from '@/translations/i18n.tsx'
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger
} from '@components/ui/dropdown-menu'
import {NavLink} from 'react-router-dom'
import {routes} from '@utilities/constants/routes.tsx'
import {PHOTOGRAPHER_RESOURCE_CENTER_URL} from '@features/insights/constants'
import {UserCard} from '@components/commons/user-card'
import {useLogout} from '@features/user/queries/useLogout.ts'
import {Spinner} from '@components/ui/spinner'

export const UserDropdown = () => {
    const {t} = useTranslation()
    const meQuery = useMe()
    const user = meQuery.data ?? raise('user is nullish')
    const logoutMutation = useLogout()

    return (
        <DropdownMenu>
            <DropdownMenuTrigger className="cursor-pointer">
                <Avatar name={user.firstName} imageUrl={user.profilePhotoUrl ?? ''} />
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" sideOffset={8} className="min-w-80">
                <UserCard user={user} />
                <DropdownMenuSeparator />
                <DropdownMenuGroup className="py-3">
                    {(!user.isInspector || user.isCreator) && (
                        <a href={PHOTOGRAPHER_RESOURCE_CENTER_URL} target="_blank" rel="noopener noreferrer">
                            <DropdownMenuItem className="px-2.5 py-3 [&_svg]:fill-neutral-900">
                                <LinkExternal01Icon size={20} />
                                {t('menu:photographer_resource_center')}
                            </DropdownMenuItem>
                        </a>
                    )}
                    <NavLink to={routes.SETTINGS.handle.fullPath}>
                        <DropdownMenuItem className="px-2.5 py-3 [&_svg]:fill-neutral-900">
                            <Settings01Icon size={20} />
                            {t('menu:settings')}
                        </DropdownMenuItem>
                    </NavLink>
                    <DropdownMenuItem
                        className="px-2.5 py-3 [&_svg]:fill-neutral-900"
                        disabled={logoutMutation.isPending}
                        onClick={event => {
                            event.preventDefault()
                            logoutMutation.mutate()
                        }}
                    >
                        <LogOut01Icon size={20} />
                        {t('menu:logout')}
                        {logoutMutation.isPending && <Spinner size={20} />}
                    </DropdownMenuItem>
                </DropdownMenuGroup>
            </DropdownMenuContent>
        </DropdownMenu>
    )
}
